//If you want to import everything from bootstrap uncomment this line and comment everything else below
//import 'bootstrap';

// Import just what we need
// https://getbootstrap.com/docs/5.0/getting-started/javascript/#using-bootstrap-as-a-module
import { Collapse, Dropdown, Tab } from 'bootstrap';

//making them global
//create a bs global object for all functions
window.bs = {};

//add the functions
window.bs.Collapse = Collapse;
window.bs.Dropdown = Dropdown;
window.bs.Tab = Tab;
